import { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { useNavigate } from "react-router-dom";

import CallIcon from '@mui/icons-material/Call';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';

import logo_long from './assets/logo_New.png';
import lotus from './assets/lotus.png';
import plume from './assets/plume.png';
import paysage from './assets/pays.jpg';
import './Home.css';
import './NotFound.css';


export default function NotFound() {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const navigate = useNavigate();

    return (
        <div class="main">
            <div class="head">
                <div>
                <img alt="sample" src={logo_long} width="100%" />
                </div>
                <div class="nav">
                    <Tabs value={value} variant="scrollable" allowScrollButtonsMobile="true" onChange={handleChange}>
                        <Tab onClick={() => navigate("/")} label="Présentation" />
                        <Tab onClick={() => navigate("/Symptomes")} label="Les Prestations" />
                        <Tab onClick={() => navigate("/Soins")} label="Déroulement Séance" />
                        <Tab onClick={() => navigate("/Guidance")} label="Guidance" />
                        <Tab onClick={() => navigate("/Tarifs")} label="Tarifs" />
                        <Tab onClick={() => navigate("/Mentions")} label="Mentions légales" />
                    </Tabs>
                </div>
            </div>
            <div class="bloc-rose">
                <img src={lotus}  alt="image" />
            </div>
            <div class="body">
                <div class="row">
                    <img class="pic" alt="sample" src={plume} width='125%' height='125%' />
                    <div class="column prez">
                        <div class="contact">
                            <h1> Erreur 404 </h1>
                        </div>
                        <p>Je suis désolé, mais la page que vous recherchez n'éxiste pas.</p>
                    </div>
                </div>
            </div>
            <div class="footer">
                <h1 class='font-flashback'>Contactez-moi</h1>
                <div class='info'>
                <h3 class="row"><LocationOnIcon /> <div class="column"><div>Rue des Perrières</div>  <div>41120 Les Montils</div></div></h3>
                <a href="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d673.8003892953336!2d1.2964262696721434!3d47.505465804141785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e355c6aac2898d%3A0xc6f15df79f0358e4!2sRue%20des%20Perri%C3%A8res%2C%2041120%20Les%20Montils!5e0!3m2!1sfr!2sfr!4v1775668708443!5m2!1sfr!2sfr" target="_blank">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d673.8003892953336!2d1.2964262696721434!3d47.505465804141785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e355c6aac2898d%3A0xc6f15df79f0358e4!2sRue%20des%20Perri%C3%A8res%2C%2041120%20Les%20Montils!5e0!3m2!1sfr!2sfr!4v1775668708443!5m2!1sfr!2sfr" 
                    width="100%" 
                    height="50%" ></iframe>
                </a>
                <h3><CallIcon /> 07 65 81 58 40</h3>
                    <h3><MailOutlineIcon /> Soinsenergetiques41@gmail.com</h3>
                </div>
                <div class='info'>
                    <h3><FacebookIcon /><a rel="noreferrer" target="_blank" href="https://www.facebook.com/soinsenergetiques41" underline="none">soinsenergetiques41</a></h3>
                    <h3><InstagramIcon /><a rel="noreferrer" target="_blank" href="https://www.instagram.com/cynthia_energeticienne_spirite/" underline="none">cynthia_energeticienne_spirite</a></h3>
                    <h3><a rel="noreferrer" target="_blank" href="https://www.resalib.fr/praticien/63425-cynthia-beaumenil-energeticien-les-montils" underline="none">RESALIB</a></h3>
                </div>
            </div>
        </div>
    )
}
